import API from "../configs/axiosInstance";

const getJiraData = (data) => {
    return API({
        url: '/account-service/v1/jira-configs/account',
        method: 'GET',
        ...data
    })
}

const createJiraIntegration = (data) => {
    return API({
        url: '/account-service/v1/jira-configs',
        method: 'POST',
        ...data
    })
}

const updateJiraIntegration = (data, id) => {
    return API({
        url: `/account-service/v1/jira-configs/${id}`,
        method: 'PUT',
        ...data
    })
}


const integrationsService = {
    getJiraData,
    createJiraIntegration,
    updateJiraIntegration
};

export default integrationsService;